import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  cmsList: any = {};
  siteDetails: any = {};
  LeadershipDetails: any

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
    this.getCms();
    this.getSettings();
    this.getLeadership();
  }

  getCms() {
    this.conn.getUrl('cms/find_cms').subscribe((res: any) => {
      if (res.status == true) {
        this.cmsList = res.data
      }
    })
  }

  getSettings() {
    this.conn.getUrl('admin/settings').subscribe((res: any) => {
      if (res.status == true) {
        this.siteDetails = res.data
      }
    })
  }
  getLeadership() {
    this.conn.getUrl('admin/get_Leadership').subscribe((res: any) => {
      if (res.status == true) {
        this.LeadershipDetails = res.data
      }
    })
  }

  
}
